"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var _Expandable = _interopRequireDefault(require("../../Expandable"));

var _DarkCheckbox = _interopRequireDefault(require("../../DarkCheckbox"));

var _AccentButton = _interopRequireDefault(require("../../Button/AccentButton"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _styles = require("./styles");

var _DarkText = _interopRequireDefault(require("../../DarkText"));

var _DarkButton = _interopRequireDefault(require("../../Button/DarkButton"));

var _class, _temp;

var Section = (0, _emotionTheming.withTheme)(_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Section, _React$Component);

  function Section(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Section);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Section).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onSectionToggleHandler", function () {
      if (!_this.state.allSelected) {
        _this.props.children.forEach(function (item) {
          if (!_this.props.selectedKeys.find(function (key) {
            return key.itemId === item.props.itemId;
          })) {
            _this.props.onChangeHandler({
              itemId: item.props.itemId,
              label: item.props.children,
              genre: item.props.genre
            }, false);
          }
        });
      } else {
        _this.props.children.forEach(function (item) {
          _this.props.onChangeHandler({
            itemId: item.props.itemId,
            label: item.props.children,
            genre: item.props.genre
          }, true);
        });
      } // if (this.props.type !== 'desktop') {
      //   this.setState({
      //     allSelected: !this.state.allSelected
      //   });
      // }

    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "expandClickHandler", function () {
      _this.setState(function (prevState) {
        return {
          expanded: !prevState.expanded
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "clickHandler", function () {
      _this.onSectionToggleHandler();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderExpandButton", function (expanded, theme) {
      return _react.default.createElement(_AccentButton.default, {
        text: expanded ? 'Less' : 'More',
        icon: {
          type: 'angle-down',
          rotate: expanded ? 180 : 0,
          style: {
            marginLeft: '6px',
            width: '11px',
            height: '11px',
            fill: theme.color.dark.amethyst
          }
        },
        iconPosition: "right",
        onClick: _this.expandClickHandler,
        style: {
          fontSize: '13px',
          color: theme.color.dark.amethyst
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "isItemVisible", function (index, expanded) {
      return expanded || index < 6;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderHeader", function (title, expanded, theme) {
      return _react.default.createElement("div", {
        className: _styles.sectionHeaderMobile,
        role: "presentation",
        onClick: _this.expandClickHandler
      }, _react.default.createElement(_DarkText.default, {
        fontSize: 16,
        bold: true,
        className: _styles.sectionTitleMobile
      }, title), _react.default.createElement("div", {
        className: _styles.iconContainer
      }, _react.default.createElement(_DarkButton.default.IconButton, null, _react.default.createElement(_Icon.default, {
        type: "angle-down",
        className: (0, _styles.toggleIconMobile)(theme, expanded)
      }))));
    });

    var selectedItemsLength = _this.props.children.filter(function (item) {
      return item.props.selected;
    }).length;

    _this.state = {
      expanded: _this.props.type === 'mobile' && selectedItemsLength,
      allSelected: _this.props.children.every(function (item) {
        return item.props.selected;
      })
    };
    return _this;
  }

  (0, _createClass2.default)(Section, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          alignItems = _this$props.alignItems,
          children = _this$props.children,
          label = _this$props.label,
          className = _this$props.className,
          theme = _this$props.theme,
          type = _this$props.type,
          selectedKeys = _this$props.selectedKeys,
          onChangeHandler = _this$props.onChangeHandler;
      var _this$state = this.state,
          expanded = _this$state.expanded,
          allSelected = _this$state.allSelected;

      var childrenWithProps = _react.default.Children.map(children, function (child) {
        return _react.default.cloneElement(child, {
          type: type,
          selectedKeys: selectedKeys,
          selected: child.props.selected || Boolean(selectedKeys.find(function (key) {
            return key.itemId === child.props.itemId;
          })),
          onChangeHandler: onChangeHandler
        });
      });

      if (type === 'desktop') {
        return _react.default.createElement("div", {
          className: (0, _classnames.default)(className, (0, _styles.rootStyleDesktop)(alignItems, theme))
        }, _react.default.createElement("div", {
          className: _styles.sectionLabelDesktop
        }, _react.default.createElement(_DarkCheckbox.default, {
          checked: allSelected,
          disabled: false,
          onChange: function onChange(event) {
            return _this2.clickHandler(event);
          },
          label: label
        })), _react.default.createElement("div", {
          className: _styles.itemsContainer
        }, childrenWithProps.map(function (child) {
          return child;
        })));
      }

      console.log({
        allSelected: allSelected
      });
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(className, (0, _styles.rootStyleMobile)(alignItems, theme, expanded))
      }, this.renderHeader(label, expanded, theme), _react.default.createElement("div", {
        key: "select-all-123",
        className: (0, _classnames.default)(_styles.rootStyleMobileItem, className, {
          expanded: expanded
        })
      }, _react.default.createElement(_DarkCheckbox.default, {
        defaultChecked: allSelected,
        disabled: false,
        onChange: function onChange(event) {
          return _this2.clickHandler(event);
        },
        label: "Select All"
      })), childrenWithProps.map(function (child) {
        return _react.default.createElement(_Expandable.default, {
          visible: expanded
        }, child);
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var selectedKeys = props.selectedKeys.map(function (item) {
        return item.itemId;
      });
      console.log(props.children.every(function (item) {
        return selectedKeys.indexOf(item.props.itemId) !== -1;
      }));
      return {
        allSelected: props.children.every(function (item) {
          return selectedKeys.indexOf(item.props.itemId) !== -1;
        })
      };
    }
  }]);
  return Section;
}(_react.default.Component), _temp)) || _class;

Section.propTypes = {
  alignItems: _propTypes.default.string,
  className: _propTypes.default.string
};
Section.defaultProps = {
  alignItems: 'end',
  className: undefined
};
var _default = Section;
exports.default = _default;